import Marquee from "react-fast-marquee";

const ITEMS = [
  "QUICK TURNAROUND",
  "QUALITY WORKMANSHIP",
  "EXPERIENCED TEAM",
  "PERTH WIDE",
  "NO UPFRONT PAYMENT",
  "RESIDENTIAL & CONSTRUCTION",
];

export default function MarqueeStrip() {
  return (
    <div data-testid="marquee-strip" className="border-y border-neutral-800 bg-obsidian py-6 overflow-hidden">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {ITEMS.map((item, i) => (
          <span key={item} className="flex items-center">
            <span
              className={`font-display font-black uppercase text-3xl md:text-5xl tracking-tight px-6 ${
                i % 2 === 0 ? "text-timber" : "text-outline"
              }`}
            >
              {item}
            </span>
            <span className="text-neutral-700 font-display text-3xl md:text-5xl px-2">//</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
